const numberBoxSx = {
  stackSx: {
    my: 4,
  },
  textFieldBoxSx: {
    width: "100%",
    margin: "0 auto",
  },
  buttonBoxSx: {
    width: "90%",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default numberBoxSx;